import React from 'react';
import '../common/_style.scss';
import 'bulma';
import {imageCdnUrls} from "../common/ImageCdnUrls";

const ExpiredPoll = () => {
    return (
        <div className="poll-portal">
            <div className="poll-form">
                <div className="communications-icon">
                    <img src={imageCdnUrls.communications} width="193" height="140"/>
                </div>
                <div className="question">Poll Closed</div>
                <div className="submit-button">The link you clicked has expired</div>
            </div>
            <div className="portal-footer">
                <div className="powered-by">Powered By</div>
                <div className="nc-logo"><img src={imageCdnUrls.logoContractsBlue} width="133" height="26"/></div>
            </div>
        </div>
    );
};

export default ExpiredPoll;
